import userServiceModule from "../userService/userService";
import path from 'path';
import carsServiceModule from "../carsService/carsService";

export default angular.module('backupService', [
	userServiceModule,
	carsServiceModule
])
	.service('backupService', function(userService, carsService, $log) {
		const BACKUP_INDEX_FILE = 'backup.index';

		this.backups = [];
		this.backupsLoaded = false;
		this.backupDir = userService.getBackupDir();

		/**
		 * Creates new backup index
		 */
		this.indexBackups = () => {
			this.backupDir = userService.getBackupDir();
			this.backups = [];

		};

		/**
		 * Loads backup index
		 */
		this.loadBackups = () => {
		};

		this.loadBackups();

		/**
		 * Returns all backups
		 * @returns {*}
		 */
		this.getBackups = () => {
			if (!this.backupsLoaded) {
				this.loadBackups();
				this.backupsLoaded = true;
			}

			return angular.copy(this.backups);
		};

		/**
		 * Removes backup and reindex
		 * @param backup
		 */
		this.removeBackup = (backup) => {
			$log.debug('Mazu zalohu', backup);
			this.indexBackups();
		};

		/**
		 * Restore backup from file
		 * @param backup
		 */
		this.restoreBackup = (backup) => {
			$log.debug('Obnovuju zalohu', backup);

			carsService.setCars(file.content);
		};

		/**
		 * Creates a backup of current DB of cars
		 */
		this.createBackup = () => {
			let cars = carsService.getCars();
		};

	}).name;



// WEBPACK FOOTER //
// build/services/backupService/backupService.js